import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react';
// import logo from "./logo.svg";
// Component inspired by Tom Miller from the GSAP community
// https://codepen.io/creativeocean/pen/NPWLwJM

import ScrambledText from "./blocks/TextAnimations/ScrambledText/ScrambledText";
import Silk from "./blocks/Backgrounds/Silk/Silk";

import MetallicPaint, {
  parseLogoImage,
} from "./blocks/Animations/MetallicPaint/MetallicPaint";
import { useState, useEffect } from "react";

// replace with your own SVG
// NOTE: your SVG should have a bit of padding around the shape, to keep it from being cut off
// it should also have black fill color, to allow the metallic effect to show through the mask
import logo from "./logo.svg";

const MetallicLogo = () => {
  const [imageData, setImageData] = useState(null);

  useEffect(() => {
    async function loadDefaultImage() {
      try {
        const response = await fetch(logo);
        const svgText = await response.text();
        const blob = new Blob([svgText], { type: "image/svg+xml" });
        const file = new File([blob], "logo.svg", { type: "image/svg+xml" });
        const parsedData = await parseLogoImage(file);
        if (parsedData && parsedData.imageData) {
          setImageData(parsedData.imageData);
        }
      } catch (err) {
        console.error("Error loading default image:", err);
      }
    }

    loadDefaultImage();
  }, []);

  if (!imageData) {
    return <div style={{ width: "100%", height: "100%" }} />;
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <MetallicPaint
        imageData={imageData}
        params={{
          edge: 0,
          patternBlur: 0.005,
          patternScale: 2,
          refraction: 0.015,
          speed: 0.3,
          liquid: 0.07,
        }}
      />
    </div>
  );
};

function HomePage() {
  return (
    <>
      <div className="silk-background">
        <Silk
          speed={5}
          scale={1.5}
          color="#262528"
          noiseIntensity={2}
          rotation={1}
        />
      </div>
      <header className="weekn-header">
        <div className="weekn-logo">
          <MetallicLogo />
        </div>
      </header>
      <div className="content-section">
        <main className="weekn-main">
          <div className="content-wrapper">
            <ScrambledText
              className="scrambled-text-demo justified-text"
              radius={30}
              duration={1.2}
              speed={0.5}
              scrambleChars=".:"
            >
              Complexity made Conversational
            </ScrambledText>

            <ScrambledText
              className="scrambled-text-demo justified-text"
              radius={30}
              duration={1.2}
              speed={0.5}
              scrambleChars=".:"
            >
              Weekn is an applied research lab reimagining the future of
              human-AI interaction. As artificial intelligence transforms how
              people engage with technology, we focus on anticipating,
              exploring, and crafting interactions that resonate deeply with
              human behavior and feel genuinely natural.
            </ScrambledText>

            <ScrambledText
              className="scrambled-text-demo justified-text"
              radius={30}
              duration={1.2}
              speed={0.5}
              scrambleChars=".:"
            >
              We envision immersive conversational systems as essential elements
              of this new user experience, capable of navigating complex
              matrixes and revealing meaningful insights effortlessly. Where
              conventional methods limit understanding and potential, we explore
              the capabilities of unsupervised AI along human intuition to
              create experiences where complexity becomes accessible, at scale.
            </ScrambledText>

            <ScrambledText
              className="scrambled-text-demo justified-text"
              radius={30}
              duration={1.2}
              speed={0.5}
              scrambleChars=".:"
            >
              We are a team of researchers and engineers transforming how people
              and AI systems understand each other, augmenting human
              decision-making and creativity. Our{" "}
              <a
                href="https://thetidelab.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-link"
              >
                work
              </a>{" "}
              is currently being showcased at La Biennale di Venezia 2025.
            </ScrambledText>

            <ScrambledText
              className="scrambled-text-demo justified-text"
              radius={30}
              duration={1.2}
              speed={0.5}
              scrambleChars=".:"
            >
              If you share our vision, we'd love to hear from you.
            </ScrambledText>

            <ScrambledText
              className="scrambled-text-demo justified-text signature"
              radius={30}
              duration={1.2}
              speed={0.5}
              scrambleChars=".:"
            >
              -{" "}
              <a
                href="https://www.albertweekn.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-link"
              >
                AM
              </a>{" "}
              &{" "}
              <a
                href="https://www.linkedin.com/in/joaquin-bressan/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-link"
              >
                JB
              </a>
            </ScrambledText>
          </div>
        </main>
        <footer className="footer">
          <p className="copyright">© 2025 Weekn Enterprises S.L.</p>
        </footer>
      </div>
    </>
  );
}

function App() {
  return (
    <div className="weekn-app">
      <Routes>
        {/* Home route */}
        <Route path="/" element={<HomePage />} />
        {/* Catch all other routes and redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Analytics />
    </div>
  );
}

export default App;
